<app-header></app-header>

<div class="wrapper">

  <app-estimate-box [isLoader]="isLoader"
    [submitBtnLabel]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'"
    (submitBtnClick)="saveListingDetails(historyState.isPaymentDone ? 'submit' : 'skip')"
    (forwardClick)="saveListingDetails(null)" (backClick)="back()"></app-estimate-box>

  <div class="section_wrapper" style="margin-top: 20px;">
    <!-- stepper component -->
    <div class="dashBoard listing_details_wrap">
      <app-stepper currentIndex="1.6" class="stepper"></app-stepper>
      <div class="listing_details w_100">
        <!-- (ngSubmit)=saveListingDetails() -->
        <form class="listing_details_form" [formGroup]="myForm">
          <h3 class="font_40_a32">Listing Details</h3>
          <div class=" form_section">
            <div class=w_100>
              <mat-form-field class="w_100 genericTextFiled_h60">
                <mat-label>Listing Price</mat-label>
                <input matInput type="number" min="0" placeholder="" name="ListPrice" required
                  formControlName="ListPrice">
                <!-- [(ngModel)]=ListPrice -->
                <span class="suffix_text" matSuffix>$</span>
              </mat-form-field>
              <mat-error class="error-message" *ngIf="myForm.get('ListPrice').hasError('required') && submitted">please
                enter
                the listing price
              </mat-error>

            </div>

            <div class="w_100">
              <mat-form-field class="example-full-width w_100 genericTextFiled_h60" appearance="fill">
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="picker" [min]="todayDate" required formControlName="OnMarketDate">
                <!-- [(ngModel)]=OnMarketDate -->
                <mat-hint>mm/dd/yyyy</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker">
                  <img src="../../../assets/icons/calendar.svg" alt="">
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-error class="error-message"
                *ngIf="myForm.get('OnMarketDate').hasError('required') && !this.myForm.get('OnMarketDate').value && submitted">please
                enter
                the listing date
              </mat-error>
            </div>


            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Seller Concessions</mat-label>
              <input matInput type="number" min="0" placeholder="" name="seller" maxlength=1024
                formControlName="ConcessionsAmount">
              <!-- [(ngModel)]=ConcessionsAmount -->
            </mat-form-field>

            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Seller Concessions Comments</mat-label>
              <input matInput type="text" placeholder="" name="comment" maxlength=1024
                formControlName="ConcessionsComments">
              <!-- [(ngModel)]=ConcessionsComments -->
            </mat-form-field>

            <div>
              <mat-form-field class="w_100 genericTextFiled_h60">
                <mat-label>Buyer Agent Commission</mat-label>
                <input matInput type="number" min="1" placeholder="" name="buyer"
                  formControlName="BuyerAgencyCompensation">
                <mat-select matSuffix class="matSuffixSelect" formControlName="BuyerAgencyCompensationType">
                  <mat-option *ngFor="let type of compensationType" [value]="type.value">
                    {{type.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="agent_Commision" style="margin-top: 6px;">
                <span>Want to know more about Agent Commission</span>
                <img src="../../../assets/icons/infor_icon.svg" matTooltipClass="commisonTooltip"
                  style="width: 20px;height: 20px;"
                  matTooltip="The current average Buyer Commission in the United States is 2.5%. Studies show that offering less than the average can impact the sale of your home. You are entitled to offer any commission you like." />
              </div>
            </div>

            <!-- 
            <mat-form-field class=" w_100 genericTextFiled_h60 " appearance=" fill">
                <mat-label>Buyer Agent Commission Type</mat-label>
                <mat-select formControlName="BuyerAgencyCompensationType" name="food">
                  <mat-option *ngFor="let type of compensationType" [value]="type.value">
                    {{type.viewValue}}
                  </mat-option>
                </mat-select>
                </mat-form-field> -->

          </div>

          <!-- <div class="submit_buttons">
            <p class="save_text" *ngIf="historyState.listingData">
              <span class="check_icon"><img src="../../../assets/icons/check_green.svg" alt="done"></span>
              Saved
            </p>

            <div class="buttons">

              <button class="back_button" *ngIf="!isLoader" (click)="saveListingDetails()">Next</button>

              <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>

              <app-green-button-v2 (click)="saveListingDetails('skip')" label="Choose Plan"
                *ngIf="!isLoader && !historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

              <app-green-button-v2 (click)="saveListingDetails('submit')" label="Submit Listing"
                *ngIf="!isLoader && historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

            </div>
          </div> -->

          <div class="mobile_submitButtons">
            <button class="arrowBtn leftArrow" (click)="back()">
              <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
            </button>
            <app-green-button-v2 class="SumbitBtnRes"
              (click)="saveListingDetails(historyState.isPaymentDone ? 'submit' : 'skip')"
              [label]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'" [buttonType]="'submit'"
              [width]="'136px'" [height]="'50px'">
            </app-green-button-v2>
            <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
            <button (click)="saveListingDetails(null)" class="arrowBtn rightArrow">
              <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>